
import { defineAsyncComponent } from 'vue'

export const SectionBreadcrumpsComponent  = defineAsyncComponent(() => import('./sections/sections.vue'))
export const SectionListComponent = defineAsyncComponent(() => import('./sections/section-list.vue'))
export const DiseaseListComponent = defineAsyncComponent(() => import('./disease-group/disease-group-list.vue'))
export const BrandListComponent = defineAsyncComponent(() => import('./brands/brand-list.vue'))
export const GenericListComponent = defineAsyncComponent(() => import('./generics/generic-list.vue'))
export const SpecialtyListComponent = defineAsyncComponent(() => import('./specialty-group/specialty-group-list.vue'))
export const NavbarComponent = defineAsyncComponent(() => import('./navigation/navbar.vue'))
